<template>
  <div v-if="userId && isAuthenticated" class="activator">
    <button
      @click="toggleActive()"
      type="button"
      class="activator__toggle-btn btn__large"
      v-tooltip="{
        content:
          !updating && !isActive
            ? 'Add To Active Courses'
            : 'Remove From Active Courses',
        placement: 'bottom-center',
      }"
    >
      {{ isActive ? 'Active' : 'Add' }}
      <ClipLoader
        v-show="updating"
        color="#fff"
        :size="1.5"
        sizeUnit="rem"
        class="activator__spinner"
      ></ClipLoader>
      <img
        class="btn__large-icon btn__large-icon--alt activator__icon"
        v-show="!updating"
        src="@/assets/icons/course/course_icon.png"
      />
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ClipLoader } from '@saeris/vue-spinners'

export default {
  name: 'CourseActivator',
  data() {
    return {
      updating: false,
    }
  },
  props: {
    course: {
      type: [Array, Object],
      required: true,
    },
  },
  components: {
    ClipLoader,
  },
  computed: {
    ...mapGetters({
      active: 'user/userActiveCourses',
      isAuthenticated: 'auth/isAuthenticated',
      userId: 'auth/userId',
    }),
    isActive() {
      if (this.active && this.active.length) {
        return this.active.find(
          activeCourse => activeCourse.id === this.course.id
        )
      }
      return null
    },
  },
  methods: {
    async toggleActive() {
      this.updating = true
      const courseAndUserIds = { courseId: this.course.id, userId: this.userId }
      if (!this.isActive) {
        await this.$store.dispatch(
          'user/postToUserActiveCourse',
          courseAndUserIds
        )
        this.$store.dispatch(
          'app/setNotification',
          'The course was saved to your active courses'
        )
      } else {
        await this.$store.dispatch(
          'user/deleteFromUserActiveCourse',
          courseAndUserIds
        )
      }
      await this.$store.dispatch('user/getUserActiveCourses', this.userId)
      this.updating = false
    },
  },
}
</script>

<style lang="scss" scoped>
.activator {
  $this: &;
  &__toggle-btn {
    &:hover {
      background-color: var(--orange);
      color: var(--white);
    }
  }
  &__spinner {
    position: absolute;
    right: 25px;
    top: 5px;
  }
  .btn__large {
    min-width: 140px;
  }
  .btn__large-icon {
    top: 8px;
    right: 12px;
    height: 20px;
  }
}
</style>
